import { createFileRoute } from '@tanstack/react-router';
import { Suspense, useState } from 'react';

import { HStack, VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';

import { EquipmentProfileHeader } from './-components/EquipmentProfileHeader';
import { EquipmentDetailOutletWithForm } from './_layout/-context/equipment-tab-form-context';
import { EquipmentFormStore } from './_layout/-store/store';

export const Route = createFileRoute('/_staff/equipment/$id/_layout')({
  component: Layout,
});

function EquipmentProfileHeaderSkeleton() {
  return (
    <VStack className="gap-4 bg-neutral-fill px-12 pt-4 shadow-xs">
      <Skeleton className="h-5 w-64" />
      <HStack className="items-start justify-between gap-6">
        <Skeleton className="size-[120px] shrink-0 rounded-md" />
        <VStack className="grow gap-2">
          <Skeleton className="h-6 w-20 rounded-full" />
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-5 w-32" />
        </VStack>
        <VStack className="shrink-0 items-end gap-2">
          <Skeleton className="h-9 w-32 rounded-md" />
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-5 w-48" />
        </VStack>
      </HStack>
      <Skeleton className="h-10 w-full" />
    </VStack>
  );
}

function Layout() {
  const [store] = useState(() => EquipmentFormStore.createStore());
  return (
    <EquipmentFormStore.Provider value={store}>
      <VStack>
        <Suspense fallback={<EquipmentProfileHeaderSkeleton />}>
          <EquipmentProfileHeader />
        </Suspense>
        <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
          <EquipmentDetailOutletWithForm />
        </Suspense>
      </VStack>
    </EquipmentFormStore.Provider>
  );
}
